var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faEllipsisV, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { EmptyComponent } from "../../utils/EmptyComponent";
import { checkKey, concatClassNames, editComponentUnmount, filterChildrenOfType, isElementOverflowing } from "../../utils/Functions";
import { Button } from "./Button";
import { Dropdown } from "./Dropdown";
import { Tooltip } from "./Tooltip";
export var TabEdit;
(function (TabEdit) {
    TabEdit[TabEdit["ADD"] = 0] = "ADD";
    TabEdit[TabEdit["DELETE"] = 1] = "DELETE";
})(TabEdit || (TabEdit = {}));
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.changeTab(_this.state.current);
            editComponentUnmount(_this.handle, _this, "resize");
            setTimeout(function () { return window.dispatchEvent(new Event("resize")); });
        };
        _this.handle = function (e) {
            _this.handleBar();
            _this.checkOverflow();
            if (e)
                _this.tabHeader.scrollLeft = 0;
            var overflown = !!_this.getOverflownButtons().find(function (d) { return d.index === _this.state.current; });
            if (overflown) {
                var current = _this.state.current, currentBtn = _this.tabHeader.querySelectorAll(".dolfo-tab-button")[current];
                _this.tabHeader.scrollLeft = currentBtn.offsetLeft;
            }
        };
        _this.handleBar = function () {
            var current = _this.state.current, buttons = _this.tabHeader.querySelectorAll(".dolfo-tab-button:not(.add)"), currentBtn = buttons[current];
            if (!currentBtn)
                return _this.changeTab(0);
            var offsetWidth = currentBtn.offsetWidth, offsetHeight = currentBtn.offsetHeight, offsetLeft = currentBtn.offsetLeft, offsetTop = currentBtn.offsetTop;
            _this.tabsBar.style.width = offsetWidth + "px";
            _this.tabsBar.style.height = offsetHeight + "px";
            _this.tabsBar.style.left = offsetLeft + "px";
            _this.tabsBar.style.top = offsetTop + "px";
        };
        _this.checkOverflow = function () {
            var isOverflowing = isElementOverflowing(_this.tabHeader);
            _this.setState({ showOverflowButton: isOverflowing });
        };
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.defaultTab !== _this.props.defaultTab && _this.props.defaultTab !== _this.state.current) {
                var children = filterChildrenOfType(_this, Tab), defaultTab = _this.props.defaultTab;
                if (children[defaultTab])
                    _this.setState({ current: defaultTab });
            }
        };
        _this.changeTab = function (current) {
            var removed = _this.state.removed, children = filterChildrenOfType(_this, Tab).filter(function (_, i) { return !removed.includes(i); }), onChange = _this.props.onChange, fn = function () { return _this.setState({ current: current }, _this.handle); };
            if (children[current] && !children[current].props.disabled) {
                if (onChange) {
                    var bool = onChange(current, children[current].props.value);
                    if (typeof bool === "boolean" && bool)
                        fn();
                    else if (bool.then) {
                        bool.then(function (d) {
                            if (d)
                                fn();
                        });
                    }
                }
                else
                    fn();
            }
        };
        _this.getOverflownButtons = function () {
            if (!_this.tabHeader)
                return [];
            var buttons = _this.tabHeader.querySelectorAll(".dolfo-tab-button"), removed = _this.state.removed;
            return Array.from(buttons).map(function (element, index) { return ({ element: element, index: index }); }).filter(function (_a) {
                var element = _a.element;
                var width = element.offsetWidth + element.offsetLeft;
                if (width > _this.tabHeader.offsetWidth + _this.tabHeader.scrollLeft || _this.tabHeader.scrollLeft > element.offsetLeft)
                    return true;
                return false;
            }).map(function (_a) {
                var element = _a.element, index = _a.index;
                var width = element.offsetWidth + element.offsetLeft;
                return {
                    isAddBtn: element.classList.contains("add"),
                    tab: filterChildrenOfType(_this, Tab).filter(function (_, i) { return !removed.includes(i); })[index],
                    index: index,
                    before: _this.tabHeader.scrollLeft > width || _this.tabHeader.scrollLeft > element.offsetLeft
                };
            });
        };
        _this.removeTab = function (index) {
            var _a = _this.state, current = _a.current, removed = _a.removed, tabs = filterChildrenOfType(_this, Tab).filter(function (_, i) { return !removed.includes(i); });
            _this.setState({ removed: removed.concat(index) }, function () {
                if (current === index && tabs.length > 1)
                    setTimeout(function () { return _this.changeTab(0); }, 200);
                else {
                    if (current > index)
                        _this.setState({ current: current - 1 }, _this.handleBar);
                    else
                        _this.handleBar();
                }
            });
        };
        _this.render = function () {
            var _a;
            var _b = _this.state, current = _b.current, removed = _b.removed, tabs = filterChildrenOfType(_this, Tab).filter(function (_, i) { return !removed.includes(i); }), _c = _this.props, style = _c.style, className = _c.className, canAdd = _c.canAdd, vertical = _c.vertical, onEdit = _c.onEdit, overflownButtons = _this.getOverflownButtons(), befores = overflownButtons.filter(function (b) { return b.before; });
            return React.createElement("div", { className: concatClassNames(["dolfo-tabs", vertical ? "vertical" : ""], className), style: style },
                React.createElement("div", { className: "dolfo-tabs-header-container" },
                    befores.length > 0 && React.createElement("div", { className: "dolfo-tabs-mask" }),
                    React.createElement("div", { className: "dolfo-tabs-header", ref: function (r) { return _this.tabHeader = r; } },
                        tabs.map(function (tab, i) {
                            var selected = current === i, _a = tab.props, disabled = _a.disabled, label = _a.label, tabClassName = _a.className, closable = _a.closable;
                            return React.createElement("div", { className: concatClassNames([
                                    "dolfo-tab-button",
                                    disabled ? "disabled" : "",
                                    selected ? "current" : ""
                                ], tabClassName), onClick: function () { return _this.changeTab(i); }, key: i, tabIndex: !disabled ? 0 : null, onKeyDown: function (e) { return checkKey(e, function () {
                                    e.target.click();
                                    e.preventDefault();
                                }, disabled); } },
                                label,
                                closable && onEdit && React.createElement(Tooltip, { label: getConfigVar("CLOSE") },
                                    React.createElement("span", { className: "dolfo-tab-close", onClick: function (e) {
                                            e.stopPropagation();
                                            var result = onEdit(TabEdit.DELETE, i), fn = function () { return _this.removeTab(i); };
                                            if (typeof result === "boolean" && result)
                                                fn();
                                            else if (result.then) {
                                                result.then(function (r) {
                                                    if (r)
                                                        fn();
                                                });
                                            }
                                        } },
                                        React.createElement(FontAwesomeIcon, { icon: faXmark, size: "lg" }))));
                        }),
                        canAdd && onEdit && React.createElement(Tooltip, { label: getConfigVar("NEW") },
                            React.createElement("div", { className: "dolfo-tab-button add", onClick: function () { return onEdit(TabEdit.ADD); }, tabIndex: 0, onKeyDown: function (e) { return checkKey(e, function () {
                                    e.target.click();
                                    e.preventDefault();
                                }); } },
                                React.createElement(FontAwesomeIcon, { icon: faPlus }))),
                        overflownButtons.length > 0 && React.createElement(Dropdown, { className: "dolfo-tabs-dropdown", closeAfterSelect: true, options: overflownButtons.map(function (_a) {
                                var tab = _a.tab, index = _a.index, isAddBtn = _a.isAddBtn;
                                return ({
                                    children: isAddBtn ? getConfigVar("ADD") : tab.props.label,
                                    disabled: !isAddBtn && tab.props.disabled,
                                    onClick: function () { return isAddBtn ? onEdit(TabEdit.ADD) : _this.changeTab(index); },
                                    className: index === befores.length - 1 ? "separator" : null
                                });
                            }) },
                            React.createElement(Tooltip, { label: getConfigVar("COLLAPSED") },
                                React.createElement(Button, { color: "white", className: "dolfo-collapsed-tabs" },
                                    React.createElement(FontAwesomeIcon, { icon: faEllipsisV })))),
                        React.createElement("div", { className: "dolfo-tabs-bar", ref: function (r) { return _this.tabsBar = r; } }))),
                React.createElement("div", { className: "dolfo-tabs-content" }, (_a = tabs[current]) === null || _a === void 0 ? void 0 : _a.props.children));
        };
        var children = filterChildrenOfType(_this, Tab);
        _this.state = {
            current: children[props.defaultTab] ? props.defaultTab : 0,
            showOverflowButton: false,
            removed: []
        };
        return _this;
    }
    return Tabs;
}(React.Component));
export { Tabs };
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Tab;
}(EmptyComponent));
export { Tab };
